<template>
  <div
    class="pb-6 flex-1 relative z-0 overflow-y-auto focus:outline-none bg-white"
  >
    <slot name="header"></slot>
    <div :class="contentStyling">
      <slot name="content"></slot>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    contentStyling: { type: String, default: "" },

    pageTitle: { type: String },
  },
};
</script>
